import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M4 13.335C4 8.306 4 5.792 5.562 4.23s4.076-1.562 9.105-1.562h2.666c5.029 0 7.543 0 9.105 1.562S28 8.306 28 13.335v5.333c0 5.028 0 7.542-1.562 9.105-1.562 1.562-4.076 1.562-9.105 1.562h-2.666c-5.029 0-7.543 0-9.105-1.562S4 23.696 4 18.668z\" opacity=\".5\"></path><path fill-rule=\"evenodd\" d=\"M9.667 16a1 1 0 0 1 1-1h10.667a1 1 0 0 1 0 2H10.667a1 1 0 0 1-1-1M9.667 10.668a1 1 0 0 1 1-1h10.667a1 1 0 0 1 0 2H10.667a1 1 0 0 1-1-1M9.667 21.332a1 1 0 0 1 1-1h6.667a1 1 0 0 1 0 2h-6.667a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"></path></g><defs><clipPath id=\"a\"><rect width=\"32\" height=\"32\" fill=\"#fff\" rx=\"5\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }